import { render, staticRenderFns } from "./NotasWebhook.vue?vue&type=template&id=be08790a&scoped=true&"
import script from "./NotasWebhook.vue?vue&type=script&lang=js&"
export * from "./NotasWebhook.vue?vue&type=script&lang=js&"
import style0 from "./NotasWebhook.vue?vue&type=style&index=0&id=be08790a&prod&lang=scss&scoped=true&"
import style1 from "./NotasWebhook.vue?vue&type=style&index=1&id=be08790a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be08790a",
  null
  
)

export default component.exports